<template>
  <div class="wrap-box">
    <div class="wrap-box-left">
      <Form ref="searchForm" :model="searchForm">
        <div v-if="isAdvanceSearch">
          <Row>
            <Col :xs="24" :sm="24" :lg="7">
              <FormItem
                :label="$t('label.project.country')"
                :label-width="60"
                style="margin-bottom: 10px;"
              >
                <Select
                  transfer
                  filterable
                  v-model="searchForm.countryId"
                  class=""
                  transfer-class-name="pbr"
                  multiple
                  :max-tag-count="0"
                  clearable
                  :placeholder="$t('label.country')"
                >
                  <Icon
                    v-if="
                      searchForm.countryId && searchForm.countryId.length > 0
                    "
                    type="md-close-circle"
                    slot="prefix"
                    style="display: flex;"
                    @click.stop="searchForm.countryId = []"
                  />
                  <template v-for="par in countryList">
                    <OptionGroup
                      :label="par.title ? par.title : $t('label.continent')"
                      :key="par.title"
                    >
                      <Option
                        v-for="child in par.children"
                        :value="JSON.stringify(child)"
                        :key="child.id"
                      >
                        {{ child.title }}
                      </Option>
                    </OptionGroup>
                  </template>
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :lg="7">
              <FormItem
                :label="$t('label.industry')"
                :label-width="60"
                style="margin-bottom: 10px;"
              >
                <Select
                  transfer
                  filterable
                  v-model="searchForm.industryId"
                  class=""
                  transfer-class-name="pbr"
                  multiple
                  :max-tag-count="0"
                  :max-tag-placeholder="maxTagPlaceholder"
                  clearable
                  :placeholder="$t('label.project.industry')"
                >
                  <Icon
                    v-if="
                      searchForm.industryId && searchForm.industryId.length > 0
                    "
                    type="md-close-circle"
                    slot="prefix"
                    style="display: flex;"
                    @click.stop="searchForm.industryId = []"
                  />
                  <Option
                    v-for="item in industryList"
                    :value="JSON.stringify(item)"
                    :key="item.id"
                    >{{ item.title }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :lg="10">
              <FormItem
                :label="$t('label.exhibition.holdDate')"
                :label-width="90"
                style="margin-bottom: 10px;"
              >
                <DatePicker
                  transfer
                  transfer-class-name="pbr"
                  :value="[searchForm.holdStartDate, searchForm.holdEndDate]"
                  @on-change="onHoldDateChange"
                  type="daterange"
                  :editable="false"
                  clearable 
                  format="yyyy-MM-dd"
                  :placeholder="$t('label.exhibition.holdDate')"
                  placement="bottom-start"
                  style="width: 100%;"
                />
              </FormItem>
            </Col>
          </Row>
        </div>
        <div style="margin-bottom: 10px;">
          <AutoComplete
            clearable
            v-model="searchForm.keywords"
            transfer
            @on-focus="
              () => {
                this.associationWordsList = [];
              }
            "
            @on-search="associationWords"
            :placeholder="$t('placeholders.exhibition.search')"
            class="auto-complete"
          >
            <Option
              v-for="item in associationWordsList"
              :value="item"
              :key="item"
              >{{ item }}</Option
            >
          </AutoComplete>

          <Button @click="search()" type="primary" style="">{{
            $t("buttons.search")
          }}</Button>
          <Button @click="reset()" style="">{{ $t("buttons.reset") }}</Button>
          <el-link
            type="text"
            :underline="false"
            @click="openHistory"
            style="color: #008bce;cursor: pointer;"
            class="padding5"
            v-html="$t('buttons.searchHistory')"
          ></el-link>
          <el-link
            v-if="isAdvanceSearch"
            class="padding5"
            type="default"
            :underline="false"
            @click="advanceSearchBtnClick(false)"
            v-html="$t('buttons.advanceRetrieval', { type: 'up' })"
          ></el-link>
          <el-link
            v-else
            class="padding5"
            type="default"
            :underline="false"
            @click="advanceSearchBtnClick(true)"
            v-html="$t('buttons.advanceRetrieval', { type: 'down' })"
          ></el-link>
        </div>
        <div class="my-condition-box">
          <label style="float:left;line-height: 27px;"
            >{{ $t("label.project.searchCondition") }}：</label
          >
          <div style="margin-left: 110px;">
            <p
              class="hold-status-tab"
              :class="{ active: searchForm.holdStatus === '0' }"
              @click="setHoldStatus('0')"
            >{{ $t("label.exhibition.upcomingExhibition") }}</p>
            <p
              class="hold-status-tab"
              :class="{ active: searchForm.holdStatus === '1' }"
              @click="setHoldStatus('1')"
            >{{ $t("label.exhibition.onGoingExhibition") }}</p>
            <p v-for="(item, key) in myCondition">
              <label>{{ item.tag }}：</label>
              <template v-if="typeof item.list === 'string'">
                <span class="condition-text">{{ item.list }}</span>
              </template>
              <template v-else>
                <span v-for="(obj, i) in item.list">
                  <span class="condition-text">
                    <i
                      @click.stop="delCondition(key, i)"
                      class="condition-item-close el-icon-error"
                    ></i
                    >{{ JSON.parse(obj).title || JSON.parse(obj).name }}
                  </span>
                  {{ i === item.list.length - 1 ? "" : "，" }}
                </span>
              </template>
              <i
                @click.stop="delCondition(key)"
                class="el-icon-circle-close condition-close"
              ></i>
            </p>
          </div>
        </div>
      </Form>
      <div class="table-top-box">
        <span class="fr right  div-xs-hidden" @click="exportPDF"
          ><span class="excel-png"></span>{{ $t("buttons.export") }}</span
        >
      </div>
      <Table
        class="pbr"
        border
        :columns="columns"
        :data="tableData"
        :loading="tableLoading"
        @on-selection-change="tableSelectionChange"
        @on-sort-change="projectListTableSortChange"
        style="margin-top: 10px;"
      >
        <template slot-scope="{ row }" slot="favorites">
          <Icon
            color="#008acd"
            @click="editFavorite(row)"
            :type="row.focue ? 'md-star' : 'md-star-outline'"
            style="font-size: 20px;cursor: pointer"
          />
        </template>
        <template slot-scope="{ row }" slot="title">
          <span
            class="project-title"
            style="cursor:pointer"
            @click.stop="jumpProjectDetail(row)"
            v-html="row.title"
          ></span>
        </template>
      </Table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
        style="margin-top: 10px"
      >
      </el-pagination>
    </div>
    <div class="wrap-box-right">
      <div class="project-data">
        <div class="pbr-title">{{ $t("label.exhibition.exhibitionData") }}</div>
        <div class="project-data-content">
          <el-row :gutter="10">
            <el-col :span="12">
              <div class="project-data-item">
                <img
                  src="../common/img/project_num.png"
                  class="project-data-item-img"
                  alt=""
                />
                <strong
                  :title="projectData.total + $t('label.project.individual')"
                  >{{ projectData.total || 0 }}</strong
                ><strong v-if="!isEN" :class="{ newline: isEN }">{{
                  $t("label.project.individual")
                }}</strong>
                <p :class="{ newline: isEN }">
                  {{ $t("label.exhibition.exhibitionNumber") }}
                </p>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="project-data-item">
                <img
                  src="../common/img/related_country.png"
                  class="project-data-item-img"
                  alt=""
                />
                <strong
                  :title="
                    projectData.countrycount + $t('label.project.individual')
                  "
                  >{{ projectData.countrycount }}</strong
                ><strong v-if="!isEN" :class="{ newline: isEN }">{{
                  $t("label.project.individual")
                }}</strong>
                <p :class="{ newline: isEN }">
                  {{ $t("label.project.countriesInvolved") }}
                </p>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <div class="project-data-item">
                <img
                  src="../common/img/project_num.png"
                  class="project-data-item-img"
                  alt=""
                />
                <strong
                  :title="
                    projectData.holdcount + $t('label.project.individual')
                  "
                  >{{ projectData.holdcount || 0 }}</strong
                ><strong v-if="!isEN" :class="{ newline: isEN }">{{
                  $t("label.project.individual")
                }}</strong>
                <p :class="{ newline: isEN }">
                  {{ $t("label.exhibition.onGoingExhibition") }}
                </p>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="project-data-item">
                <img
                  src="../common/img/relate_industry.png"
                  class="project-data-item-img"
                  alt=""
                />
                <strong
                  :title="
                    projectData.industrycount + $t('label.project.individual')
                  "
                  >{{ projectData.industrycount }}</strong
                ><strong v-if="!isEN" :class="{ newline: isEN }">{{
                  $t("label.project.individual")
                }}</strong>
                <p :class="{ newline: isEN }">
                  {{ $t("label.project.industriesInvolved") }}
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="project-chart-box">
        <div class="pbr-title">{{ $t("label.exhibition.exhibitionHotWords") }}</div>
        <div class="project-chart">
          <HotWordAnalysis
            v-if="hotWordData.length"
            ref="hotWordChart"
            :word-data="hotWordData"
            @hotClick="hotClick"
          ></HotWordAnalysis>
          <Empty v-else></Empty>
        </div>
      </div>
    </div>
    <PublishProject ref="publish"></PublishProject>
    <el-dialog
      :visible.sync="historyModal"
      :modal="false"
      :title="$t('table.project.history.title')"
      append-to-body
      custom-class="pbr"
      width="600px"
    >
      <div style="text-align: right;margin-bottom: 10px;">
        <Button @click="delAllHistory" type="primary">{{
          $t("buttons.delAll")
        }}</Button>
      </div>
      <Table
        border
        :columns="historyColumns"
        :data="historyTableData"
        @on-row-click="dblclickHistory"
        class="pbr-info-history-table"
      >
        <template slot-scope="{ row }" slot="top">
          <div @click.stop="toTopHistory(row)" style="cursor:pointer;">
            <Icon
              :class="favIconClass(row)"
              type="md-arrow-round-up"
              style="font-size: 20px;"
            />
          </div>
        </template>
        <template slot-scope="{ row }" slot="operate">
          <Icon
            @click.stop="delHistory(row)"
            v-if="!row.del"
            type="md-trash"
            style="font-size: 20px;cursor:pointer;"
          />
        </template>
      </Table>
    </el-dialog>
    <div v-show="false" ref="submitForm">
      <form
        method="get"
        target="_blank"
        enctype="multipart/form-data"
        :action="action"
      >
        <input name="selections" type="text" />
        <input name="from" type="text" value="cn" />
      </form>
    </div>
  </div>
</template>

<script>
import PublishProject from "./PublishProject";
import HotWordAnalysis from "../analysis/HotWordAnalysis";
import { contentType, exportFilePost } from "../apis/common";

export default {
  name: "pbrExhibition",
  components: {
    PublishProject,
    HotWordAnalysis,
  },
  data() {
    return {
      action: this.$pbrApis.exportExhibitionListUrl,
      questionVisible: false,
      isSmall: false,
      searchForm: {
        countryId: [],
        industryId: [],
        holdStartDate: "",
        holdEndDate: "",
        nextStartDate: "",
        orderby: "desc"
      },
      associationWordsList: [],
      countryList: [],
      industryList: [],
      showMoreCondition: false,
      /**/
      myCondition: {},
      /**/
      tableLoading: false,
      columns: [],
      tableData: [],
      tableSelection: [],
      currentPage: 1,
      pageSize: 10,
      tableTotal: 0,
      /**/
      projectData: {
        projectcount: 0,
        countrycount: 0,
        totalamount: 0,
        industrycount: 0
      },
      hotWordData: [],
      /**/
      historyModal: false,
      historyColumns: [
        {
          title: this.$t("table.project.history.columns.top"),
          width: 50,
          slot: "top",
          align: "center"
        },
        {
          title: this.$t("table.project.history.columns.title"),
          key: "name"
        },
        {
          title: this.$t("table.project.history.columns.delete"),
          width: 80,
          slot: "operate",
          align: "center"
        }
      ],
      historyTableData: [],
      isAdvanceSearch: false,
      locale: localStorage.getItem("locale"),
      /** 避免 mounted 与 activated 首次重复请求 */
      skipActivatedSearch: false
    };
  },
  computed: {
    isDark() {
      return this.$store.state.brpaModule.theme === "dark";
    },
    isEN() {
      return (
        localStorage.getItem("locale") &&
        localStorage.getItem("locale") === "en"
      );
    }
  },
  created() {
    this.getConditions();
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    // 嵌套在 Index 内，首次进入页面时 activated 不一定触发数据加载
    this.skipActivatedSearch = true;
    this.search();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === "/pbr/exhibition/detail") {
      sessionStorage.setItem("isBack", 1);
    }
    next();
  },
  activated() {
    if (this.$route.query.key && this.$route.query.n) {
      this.searchForm.countryId = [
        JSON.stringify({
          id: this.$route.query.key,
          title: this.$route.query.n
        })
      ];
      this.isAdvanceSearch = true;
    }
    const isBack = sessionStorage.getItem("isBack") || 0;
    if (isBack == 1) {
      sessionStorage.removeItem("isBack");
      return;
    }
    if (this.skipActivatedSearch) {
      this.skipActivatedSearch = false;
      return;
    }
    this.search();
  },
  methods: {
    onHoldDateChange(val) {
      this.$set(this.searchForm, "holdStartDate", val && val[0] ? val[0] : "");
      this.$set(this.searchForm, "holdEndDate", val && val[1] ? val[1] : "");
    },
    delCondition(key, i) {
      if (key === "holdDate") {
        this.searchForm.holdStartDate = "";
        this.searchForm.holdEndDate = "";
      } else {
        const dateKeys = ["nextStartDate", "nextEndDate"];
        if (dateKeys.includes(key)) {
          this.searchForm[key] = "";
        } else if (i !== undefined && i !== null) {
          this.searchForm[key].splice(i, 1);
        } else {
          this.$set(this.searchForm, key, undefined);
        }
      }
      this.search();
    },
    delAllHistory() {
      this.$pbrApis
        .deleteAllExhibitionSearchHistory({
          type: "front",
          subtype: "exhibition"
        })
        .then(() => {
          this.getHistoryList();
        });
    },
    handleResize() {
      let that = this;
      let fullWidth = document.documentElement.clientWidth;
      if (fullWidth <= 992 && !that.isSmall) {
        that.isSmall = true;
      }
      if (fullWidth > 992 && that.isSmall) {
        that.isSmall = false;
      }

      this.columns = [
        {
          type: "selection",
          width: 40,
          align: "center",
          fixed: "left"
        },
        //   {
        //     title: " ",
        //     width: 40,
        //     slot: "favorites",
        //     align: "center",
        //     fixed: "left"
        //   },
        {
          title: this.$t("table.exhibition.main.name"),
          slot: "title",
          minWidth: 200,
          className: "table-head-style",
          fixed: "left"
        },
        {
          title: this.$t("table.project.main.country"),
          key: "countryName",
          width: 120,
          align: "center",
          className: "table-head-style",
          sortable: "custom"
        },
        {
          title: this.$t("table.exhibition.main.city"),
          key: "cityName",
          width: 120,
          align: "center",
          className: "table-head-style",
          sortable: "custom"
        },
        {
          title: this.$t("table.exhibition.main.holdDate"),
          key: "startDate",
          width: 200,
          align: "center",
          className: "table-head-style",
          render: (h, params) => {
            return h(
              "span",
              params.row.holdStartDate + " - " + params.row.holdEndDate
            );
          }
        },
        {
          title: this.$t("table.exhibition.main.holdCycle"),
          key: "cycleNum",
          width: 120,
          align: "center",
          className: "table-head-style",
          render: (h, params) => {
            const parts = [];
            if (params.row.cycleNum != null && params.row.cycleUnit) {
              parts.push(`${params.row.cycleNum}${params.row.cycleUnit}`);
            }
            if (params.row.cycleTimes != null) {
              parts.push(
                `${params.row.cycleTimes}${this.$t("label.exhibition.cycleTimes")}`
              );
            }
            return h("span", parts.join(""));
          }
        },
        {
          title: this.$t("table.exhibition.main.industry"),
          key: "industryName",
          width: 120,
          className: "table-head-style",
          sortable: "custom"
        }
      ];
    },

    projectAmountForTooltip(data) {
      let count = parseFloat(data);
      if (!isNaN(count)) {
        if (this.isEN) {
          return count / 10 + " " + this.$t("label.project.HM");
        }
        return count + " " + this.$t("label.project.HM");
      }
      return "";
    },
    favIconClass(row) {
      if (row.up) {
        if (this.isDark) {
          return { "fav-icon-dark-active": true };
        }
        return { "fav-icon-active": true };
      } else {
        if (this.isDark) {
          return { "fav-icon-dark": true };
        }
        return { "fav-icon": true };
      }
    },
    advanceSearchBtnClick(advance) {
      this.isAdvanceSearch = advance;
    },
    projectListTableSortChange(options) {
      let { key, order } = options;
      const orderkeyEnum = {
        countryName: "gj",
        cityName: "cs",
        industryName: "hy"
      };
      if (order === "normal") {
        this.searchForm.orderby = "desc";
        this.searchForm.orderkey = "";
      } else {
        this.searchForm.orderby = order;
        this.searchForm.orderkey = orderkeyEnum[key] || "";
      }
      this.search();
    },
    maxTagPlaceholder(num) {
      return "... " + num;
    },
    tableSelectionChange(selection) {
      this.tableSelection = selection;
    },
    openPublishModal() {
      this.$refs.publish.open();
    },
    jumpAnalysis() {
      this.$router.push({
        path: "/pbr/analysis",
        query: {
          from: "project",
          conditions: this.getSearchParams(),
          myCondition: this.myCondition
        }
      });
    },
    exportPDF() {
      let that = this;
      if (this.tableSelection.length === 0) {
        this.$confirm(
          that.$t("message.warning.prompt.export"),
          that.$t("message.warning.prompt.title"),
          {
            confirmButtonText: that.$t("buttons.ok"),
            cancelButtonText: that.$t("buttons.cancel"),
            type: "warning"
          }
        )
          .then(() => {
            exportFilePost(
              `${this.action}?pageNo=${this.currentPage}&pageSize=${this.pageSize}`,
              this.getSearchParams(),
              this.$t("label.export.exhibitionList"),
              contentType.excel,
              ".xlsx"
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: that.$t("message.warning.prompt.exportFailure")
            });
          });
      } else {
        const selections = this.tableSelection
          .map(t => `${t.id}${this.locale}`)
          .join(",");
        exportFilePost(
          `${this.action}?pageNo=${this.currentPage}&pageSize=${
            this.pageSize
          }&selections=${encodeURIComponent(selections)}`,
          this.getSearchParams(),
          this.$t("label.export.exhibitionList"),
          contentType.excel,
          ".xlsx"
        );
      }
    },
    /**/
    getConditions() {
      this.$pbrAxios
        .post("/front/project/gconditions", { from: this.locale })
        .then(res => {
          if (res && res.code === 200) {
            this.countryList = res.result.regionModels.children;
            this.industryList = res.result.industryModels;
          }
        })
        .catch(() => {});
    },
    filterIds(list) {
      if (!list || !list.length) return "";
      return list.map(item => JSON.parse(item).id).join(",");
    },
    getSearchParams() {
      return {
        countryId: this.filterIds(this.searchForm.countryId),
        industryId: this.filterIds(this.searchForm.industryId),
        holdStartDate: this.searchForm.holdStartDate || "",
        holdEndDate: this.searchForm.holdEndDate || "",
        holdStatus: this.searchForm.holdStatus || "",
        searchkey: this.searchForm.keywords|| "",
        orderby: this.searchForm.orderby || "desc",
        orderkey: this.searchForm.orderkey || ""
      };
    },
    getTableData() {
      this.$iSpin.show();
      const body = this.getSearchParams();
      const query = { pageNo: this.currentPage, pageSize: this.pageSize };
      this.$pbrApis
        .fetchExhibitionList(body, query)
        .then(data => {
          if (data.success) {
            this.tableTotal = data.result.total;
            this.tableData = data.result.records;
            this.$pbrApis.saveExhibitionSearchHistory(body);
          } else {
            this.tableTotal = 0;
            this.tableData = [];
          }
          this.$iSpin.hide();
        })
        .catch(() => {
          this.$iSpin.hide();
        });
    },
    reset(flag) {
      this.searchForm = {
        countryId: [],
        industryId: [],
        holdStartDate: "",
        holdEndDate: "",
        holdStatus: "",
        keywords: "",
        orderby: "desc",
        orderkey: "",
        searchkeys: ""
      };
      this.myCondition = {};
      if (!flag) {
        this.search();
      }
    },
      setHoldStatus(status) {
        this.searchForm.holdStatus =
          this.searchForm.holdStatus === status ? "" : status;
        this.search();
      },
      search() {
        if (this.searchForm.keywords && this.searchForm.keywords.length > 100) {
          return;
        }
        this.currentPage = 1;
        this.getTableData();
        this.getProjectData();
        this.getProjectHotWord();
      },
    associationWords(keyword) {
      if (keyword && keyword.length > 100) {
        //this.$iMessage.error({content: this.$t('message.error.maximum100'), duration: 5})
        return;
      }
      // type（0项目搜索   1项目资讯搜索  2商机资讯搜索   3风险资讯搜索   4风险事件搜索  5分析页搜索）

      this.$pbrApis
        .associationWords({ keyword: keyword, type: 0 })
        .then(res => {
          if (res.success) {
            this.associationWordsList = res.result.models;
          }
        });
    },
    /**/
    addFavorites(row, stat) {
      this.$pbrAxios
        .post("/front/project/pfocus", {
          id: row.id,
          focus: stat
        })
        .then(data => {
          this.getTableData();
          //stat ? this.$iMessage.success('收藏成功！') : this.$iMessage.success('取消收藏！')
        });
    },
    jumpProjectDetail(row) {
      this.$router.push({
        name: "pbrExhibitionDetail",
        params: row,
        query: {
          key: row.id,
          tab: "exhibition",
          lang: row.lang || (this.locale === "en" ? "en" : "cn")
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    /*统计*/
    isApiSuccess(data) {
      return data && (data.success || data.code === 200);
    },
    getProjectData() {
      this.$pbrApis
        .fetchExhibitionStatistic(this.getSearchParams())
        .then(data => {
          if (this.isApiSuccess(data) && data.result) {
            this.projectData = data.result;
          }
        });
    },
    getProjectHotWord() {
      this.$pbrApis
        .fetchExhibitionHotWord(this.getSearchParams())
        .then(data => {
          if (this.isApiSuccess(data)) {
            const result = data.result;
            this.hotWordData = Array.isArray(result) ? result : [];
            this.$nextTick(() => {
              if (this.$refs.hotWordChart) {
                this.$refs.hotWordChart.resize();
              }
            });
          }
        });
    },
    hotClick(hotWord) {
      this.searchForm.keywords = hotWord;
      this.search();
    },
    updateHoldDateCondition() {
      const { holdStartDate, holdEndDate } = this.searchForm;
      if (holdStartDate || holdEndDate) {
        const list =
          holdStartDate && holdEndDate
            ? holdStartDate + " - " + holdEndDate
            : holdStartDate || holdEndDate;
        this.$set(this.myCondition, "holdDate", {
          tag: this.$t("label.exhibition.holdDate"),
          list
        });
      } else {
        this.$delete(this.myCondition, "holdDate");
      }
      this.$delete(this.myCondition, "holdStartDate");
      this.$delete(this.myCondition, "holdEndDate");
    },
    updateNextDateCondition() {
      const { nextStartDate, nextEndDate } = this.searchForm;
      if (nextStartDate) {
        this.$set(this.myCondition, "nextStartDate", {
          tag: this.$t("label.exhibition.nextStartDate"),
          list: nextStartDate
        });
      } else {
        this.$delete(this.myCondition, "nextStartDate");
      }
      if (nextEndDate) {
        this.$set(this.myCondition, "nextEndDate", {
          tag: this.$t("label.exhibition.nextEndDate"),
          list: nextEndDate
        });
      } else {
        this.$delete(this.myCondition, "nextEndDate");
      }
    },
    openHistory() {
      this.historyModal = true;
      this.getHistoryList();
    },
    getHistoryList() {
      this.$pbrApis.fetchExhibitionSearchHistory({}).then(data => {
        if (data && data.result) {
          this.historyTableData = data.result;
        }
      });
    },
    matchMultiSelect(list, idsStr) {
      if (!idsStr) return [];
      const ids = idsStr.split(",");
      const result = [];
      (list || []).forEach(o => {
        if (o.children) {
          o.children.forEach(c => {
            if (ids.indexOf(c.id) > -1) {
              result.push(JSON.stringify({ id: c.id, title: c.title }));
            }
          });
        }
        if (ids.indexOf(o.id) > -1) {
          result.push(JSON.stringify({ id: o.id, title: o.title }));
        }
      });
      return result;
    },
    dblclickHistory(row) {
      console.log("dblclickHistory", row);
      const cond = row.conditions || {};
      const countryId = this.matchMultiSelect(this.countryList, cond.countryId);
      const industryId = (this.industryList || [])
        .filter(o => cond.industryId && cond.industryId.indexOf(o.id) > -1)
        .map(o => JSON.stringify(o));
      this.searchForm = {
        countryId,
        industryId,
        holdStartDate: cond.holdStartDate || "",
        holdEndDate: cond.holdEndDate || "",
        nextStartDate: cond.nextStartDate || "",
        nextEndDate: cond.nextEndDate || "",
        holdStatus: cond.holdStatus || "",
        keywords: cond.searchkey || "",
        orderby: cond.orderby || "desc",
        orderkey: cond.orderkey || "",
        searchkeys: ""
      };
      this.historyModal = false;
      this.isAdvanceSearch = true;
      this.search();
    },
    toTopHistory(row) {
      this.$pbrApis
        .pinExhibitionSearchHistory({ id: row.id, up: !row.up })
        .then(() => {
          if (row.up) {
            row.up = false;
          } else {
            row.up = true;
          }
          this.getHistoryList();
        });
    },
    delHistory(row) {
      this.$pbrApis
        .deleteExhibitionSearchHistory({ id: row.id })
        .then(() => {
          this.getHistoryList();
        });
    },
    editFavorite(row) {
      let that = this;
      let type = row.focue ? "delete" : "add";
      this.$pbrApis
        .editFavorite(type, { id: row.id, type: 3 })
        .then(res => {
          if (!res) {
            //this.$iMessage.error({content: this.$t('message.error.favorite'), duration: 5})
          } else if (res.code === 200) {
            console.log("收藏", res);
            this.$iMessage.success({
              content:
                type === "add"
                  ? this.$t("message.success.favorite")
                  : this.$t("message.success.unfavored"),
              duration: 5
            });
            this.getTableData();
          }
        })
        .catch(err => {
          this.$iMessage.error({ content: err.message, duration: 5 });
        });
    }
  },
  watch: {
    "searchForm.countryId"(val) {
      if (val && val.length > 0) {
        this.myCondition.countryId = {
          tag: this.$t("label.country"),
          list: val
        };
      } else {
        delete this.myCondition.countryId;
      }
    },
    "searchForm.industryId"(val) {
      if (val && val.length > 0) {
        this.myCondition.industryId = {
          tag: this.$t("label.industry"),
          list: val
        };
      } else {
        delete this.myCondition.industryId;
      }
    },
    "searchForm.holdStartDate"(val) {
      this.updateHoldDateCondition();
    },
    "searchForm.holdEndDate"() {
      this.updateHoldDateCondition();
    },
    "searchForm.nextStartDate"() {
      this.updateNextDateCondition();
    },
    "searchForm.nextEndDate"() {
      this.updateNextDateCondition();
    }
  }
};
</script>
<style scoped>
.wrap-box .my-condition-box .hold-status-tab {
  cursor: pointer;
  padding-right: 8px;
  border-color: #eee;
  color:#666;
}
.wrap-box .my-condition-box .hold-status-tab.active {
  border-color: #409eff;
  background-color: #ecf5ff;
  color:#409eff;
}

.project-title:hover {
  color: #33a2d7;
}

.project-data-content {
  padding: 20px 10px;
}

.pbr-info-history-table >>> .ivu-table td {
  cursor: pointer;
}

>>> .ivu-table th.table-head-style {
  text-align: center;
}

>>> .ivu-table-tbody span {
  word-break: break-word;
}
</style>
